import { NftFiltersMoleculeReatom } from "@/app/nft/search/filters/store.reatom"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

export const EmptyMessage = reatomComponent(() => {
  const { appliedFiltersCount } = useMolecule(NftFiltersMoleculeReatom)
  const count = appliedFiltersCount()

  return (
    <div className="flex max-w-[600px] flex-col items-center gap-2">
      <div className="flex flex-col items-center gap-1">
        <h2 className="items-center text-xl">
          <Trans>No items found</Trans>
        </h2>
        {count ? (
          <span className="text-center text-foreground/60">
            <Trans>
              Try adjusting your filters to find what you're looking for
            </Trans>
          </span>
        ) : null}
      </div>
    </div>
  )
}, "EmptyMessage")
